import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


// Global fetch patch to bust asset cache (Step 3)
const version = localStorage.getItem('appVersion') || Date.now().toString();
const originalFetch = window.fetch;

window.fetch = function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  let url: string;
  if (typeof input === 'string') {
    url = input;
  } else if (input instanceof Request) {
    url = input.url;
  } else if (input instanceof URL) {
    url = input.toString();
  } else {
    return originalFetch(input, init); // fallback, unlikely case
  }

  // Append version query param for assets (excluding version.json)
  if (url.includes('assets/') && !url.includes('version.json')) {
    const sep = url.includes('?') ? '&' : '?';
    url += `${sep}v=${version}`;
  }

  // Reconstruct the request if needed
  const finalInput = typeof input === 'string' || input instanceof URL ? url : new Request(url, input);

  return originalFetch(finalInput, init);
};

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
